import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20fashion%20marketplace%20banner%20with%20abstract%20product%20elements%20and%20soft%20gradient%20lighting%2C%20modern%20ecommerce%20aesthetic%2C%20warm%20champagne%20and%20ivory%20tones%20with%20subtle%20coral%20accents%2C%20professional%20commercial%20photography%20style%2C%20clean%20spacious%20composition%20with%20central%20copy%20space%2C%20aspirational%20shopping%20atmosphere&width=1200&height=500&seq=cta-banner-v2&orientation=landscape"
            alt="Mulebuy spreadsheet CTA"
            className="w-full h-48 md:h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent"></div>
        </div>

        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight max-w-2xl mx-auto">
            Stop searching. Start sourcing with the best{' '}
            <span className="italic text-primary-500">mulebuy spreadsheet</span> today.
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Access the most updated mulebuy spreadsheet resources and improve your sourcing efficiency instantly. Join thousands of buyers who trust our verified data.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-white font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Access Kaspreadsheet Now
              <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-900 text-foreground-900 font-semibold text-sm hover:bg-foreground-900 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Compare Now
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}